import { Navigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { loginedUser } from "../store/actions/authAction";
import Loading from "../components/Loading";

const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const { isAuthonticated, isCheckingAuth } = useSelector(
    (state) => state.auth,
  );
  const token = localStorage.getItem("cardsToken");

  useEffect(() => {
    if (token && !isAuthonticated) {
      dispatch(loginedUser());
    }
  }, [dispatch, isAuthonticated, token]);

  if (!token) {
    return <Navigate to="/user/login" replace />;
  }
  if (isCheckingAuth) {
    return <Loading />; 
  }

  return isAuthonticated ? <Outlet /> : <Navigate to="/user/login" replace />;
};

export default ProtectedRoute;